import { Slot } from '@radix-ui/react-slot';
import type * as React from 'react';

import { Tooltip } from '@/atoms/Tooltip/Tooltip';

import { useBookmarkContext } from './context';

export const Trigger = ({ asChild = true, children, label }: TriggerType) => {
  const { disabled, handleToggle, isBookmarked } = useBookmarkContext();

  const Comp = asChild ? Slot : 'button';

  return (
    <Tooltip label={label}>
      <Comp disabled={disabled}>
        {children({ checked: isBookmarked, handleToggle })}
      </Comp>
    </Tooltip>
  );
};

type TriggerType = {
  asChild?: true;
  children: (props: ChildrenType) => React.ReactNode;
  label?: string;
};

type ChildrenType = {
  checked: boolean;
  handleToggle: () => void;
};
